/**
 * @module design/cardLayout
 * @description Layout proportions for the postcard faces.
 *
 * // WORKAROUND (client direction): the photo/story division is no longer
 * the golden ratio (61.8 / 38.2).
 * What caused this: Samantha asked for larger titles and figures with "more
 * width across the card" (notes, 2026-10-01) and supplied a reference layout
 * (_sources/AFJ_To_Jamaica_With_Love_Four_New_Postcards_Review 2.pdf).
 * Why chosen: the share below is measured from that reference (photo frame
 * 495 of 905 px of live width ≈ 0.55), so the build matches what the client
 * approved rather than our 1A proportion. Side-effects: the story column is
 * ~17% wider; the golden tokens still drive spacing and the type scale.
 */

/** Share of the card body width given to the photo column. */
export const STORY_PHOTO_SHARE = 0.55;

/** Thank-you front: the portrait photo column (measured from Samantha's PNG, 577 of 1715 px live width). */
export const THANK_YOU_PHOTO_SHARE = 0.34;
